import { axiosInstance, axiosNodeInstance } from "./config";
import { getAuthToken } from "./sessionExpiry";

export const fetchData = async (toggleLoading, apiName, token) => {
    try {
        if (toggleLoading)
            toggleLoading(true);
        const res = await axiosInstance.get(`/${apiName}`, {
            headers: {
                Authorization: `Bearer ${token || getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading)
            toggleLoading(false);
        return res.data
    } catch (error) {
        console.error(error);
        if (toggleLoading)
            toggleLoading(false);
    }
}
export const fetchNodeData = async (toggleLoading, apiName, token) => {
    try {
        if (toggleLoading)
            toggleLoading(true);
        const res = await axiosNodeInstance.get(`/${apiName}`, {
            headers: {
                Authorization: `Bearer ${token || getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading)
            toggleLoading(false);
        return res.data
    } catch (error) {
        console.error(error);
        if (toggleLoading)
            toggleLoading(false);
    }
}

export const FetchPostData = async (toggleLoading, apiName, token, formDataEntries) => {
    try {
        if (toggleLoading)
            toggleLoading(true);
        const formData = new FormData();
        for (const [key, value] of Object.entries(formDataEntries)) {
            formData.append(key, value);
        }
        const res = await axiosInstance.post(`${apiName}`, formDataEntries, {
            headers: {
                Authorization: `Bearer ${token || getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading)
            toggleLoading(false);
        return res
    } catch (error) {
        console.error(error);
        if (toggleLoading)
            toggleLoading(false);
    }
}

export const FetchNodePostData = async (toggleLoading, apiName, token, formDataEntries) => {
    try {
        if (toggleLoading) toggleLoading(true);
        const formData = new FormData();
        for (const [key, value] of Object.entries(formDataEntries)) {
            formData.append(key, value);
        }
        const res = await axiosNodeInstance.post(`${apiName}`, formDataEntries, {
            headers: {
                Authorization: `Bearer ${token || getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading) toggleLoading(false);
        return res
    } catch (error) {
        console.error(error);
        if (toggleLoading) toggleLoading(false);
    }
}
// PUT - Update
export const FetchNodePutData = async (toggleLoading, nodeUrl, id, formDataEntries) => {
    try {
        if (toggleLoading)
            toggleLoading(true);
        const res = await axiosNodeInstance.put(`/${nodeUrl}/${id}`, formDataEntries, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading)
            toggleLoading(false);
        return res;
    } catch (error) {
        console.error(error);
        if (toggleLoading)
            toggleLoading(false);
    }
};

// DELETE - Remove
export const FetchNodeDeleteData = async (toggleLoading, nodeUrl, id) => {
    try {
        if (toggleLoading)
            toggleLoading(true);
        const res = await axiosNodeInstance.delete(`/${nodeUrl}/${id}`, {
            headers: {
                Authorization: `Bearer ${getAuthToken()}`,
            }
        });
        if (res.status === 401) {
            window.dispatchEvent(new Event('session_expired'));
        }
        if (toggleLoading)
            toggleLoading(false);
        return res;
    } catch (error) {
        console.error(error);
        if (toggleLoading)
            toggleLoading(false);
    }
};